import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import type { OnlineFunnel } from "~/constants/Funnel";
import type {
  PrimeActiveFunnels,
  PrimeSitePropertiesMyTripsReactivationQueryQuery,
  PrimeSitePropertiesQueryQuery,
} from "~/generated/graphql";
import { GET_PRIME_SITE_PROPERTIES } from "../providers/operations/primeSiteProperties/primeSiteProperties";
import { GET_PRIME_SITE_PROPERTIES_MY_TRIPS_REACTIVATION } from "../providers/operations/primeSiteProperties/primeSitePropertiesMyTripsReactivation";

const usePrimeSitePropertiesQuery =
  (): UseQueryResult<PrimeSitePropertiesQueryQuery> => {
    return useQuery<PrimeSitePropertiesQueryQuery>(GET_PRIME_SITE_PROPERTIES);
  };

const usePrimeSitePropertiesMyTripsReactivationQuery =
  (): UseQueryResult<PrimeSitePropertiesMyTripsReactivationQueryQuery> => {
    return useQuery<PrimeSitePropertiesMyTripsReactivationQueryQuery>(
      GET_PRIME_SITE_PROPERTIES_MY_TRIPS_REACTIVATION,
    );
  };

const isActiveFunnel = (
  funnel: OnlineFunnel,
  primeActiveFunnels: PrimeActiveFunnels | null | undefined,
): boolean => primeActiveFunnels?.[funnel] || false;

export const useIsActivePrimeMarket = (
  currentFunnel: OnlineFunnel,
): boolean => {
  const { data, loading } = usePrimeSitePropertiesQuery();
  return !data && loading
    ? true
    : isActiveFunnel(
        currentFunnel,
        data?.primeSiteProperties?.activePrimeMarket,
      );
};

export const useIsPrimeMarket = (): boolean => {
  const { data, loading, errors } =
    usePrimeSitePropertiesMyTripsReactivationQuery();
  return !data && !errors && loading
    ? true
    : data?.primeSiteProperties?.isPrimeMarket || false;
};

export default usePrimeSitePropertiesQuery;
